<template>
    <div class="container">
        <p style="font-size: 24px; font-weight: bold">隐私政策说明</p>
        <div class="content">
            {{content}}
        </div>
        <p style="font-size: 16px;margin-top: 20px; text-align: right; margin-right: 30px;">
            <span style="font-weight: bold; line-height: 24px">深圳市八度云计算信息技术有限公司</span>
            <br/>
            <span style="font-weight: bold; line-height: 24px">2020年12月25日</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                content: '本应用非常重视用户隐私政策并严格遵守相关的法律规定。请您仔细阅读《隐私政策》后再继续使用。如果您继续使用本应用，表示您已经充分阅读和理解我们协议的全部内容。\n' +
                    '\n' +
                    '本app尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更优质的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。\n' +
                    '\n' +
                    '1. 适用范围\n' +
                    '(a)本app属于内部使用，无需注册账号，相应的账号都已分配好。\n' +
                    '(b)本应用严禁用户在拨打电话时散播不良信息，如色情和亵渎内容，通话内容我们会进行审核，一经发现不良信息，会禁用该用户的所有权限，予以封号处理，同时告知企业管理者。\n' +
                    '\n' +
                    '2. 信息使用\n' +
                    '(a)本应用不会向任何无关第三方提供、出售、出租、分享或交易通话信息。\n' +
                    '(b)本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播相关通话信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户及公司的服务协议。\n' +
                    '\n' +
                    '3. 信息存储和交换\n' +
                    '\n' +
                    '本应用收集的有关信息和资料将保存在建设单位的服务器上。\n' +
                    '\n' +
                    '4. Cookie的使用\n' +
                    '\n' +
                    '(a) 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务。\n' +
                    '(b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。\n' +
                    '(c) 通过本应用所设cookies所取得的有关信息，将适用本政策。\n' +
                    '\n' +
                    '5.本隐私政策的更改\n' +
                    '\n' +
                    '如果决定更改隐私政策，我们会在本政策中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集项目信息。\n' +
                    '请您妥善保护自己的账号信息，如您发现自己的账号信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用管理员，以便本应用采取相应措施。\n' +
                    '感谢您花时间了解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！'
            };
        }
    };
</script>

<style scoped>
    .container {
        max-width: 20rem;
        margin: 0 auto;
        padding: 50px 0;
    }

    .content {
        padding: 10px 20px;
        text-align: left;
        font-size: 14px;
        color: #444444;
        line-height: 20px;
        white-space: pre-line;
    }
</style>
